export default __webpack_public_path__ + "static/project-slide-6-1248-765-3ffdfbea6ca79010b3f972d7462902db.jpg";